import * as profilesApi from 'services/api/profiles-api';
import { types } from './features-types';
import { Application } from 'services/enums';
import * as persistentDataActions from 'app/request/persistent-data-actions';

export function loadApplicationFeatures(identityId, features) {
  const action = state => profilesApi.getApplicationFeatures(Application.MemberApp, features, state);
  return persistentDataActions.request(action, types.DISABLED_FEATURES, identityId);
}
